<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-6">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="cnpj">CNJ:</label>
                        <input id="cnpj" type="text" readonly="readonly" :value="cnj"
                               class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>

        <hr class="mt-4"/>

        <b-row v-for="devedorLista in devedores">
            <b-col md="2">
                <b-form-group
                        label="CPF / CNPJ do Devedor:"
                        label-for="cpf"
                        class="text-label">
                    <b-form-input
                            type="text"
                            id="num-documento"
                            data-vv-as="CPF"
                            v-model="devedorLista.cpfCnpj"
                            disabled
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                        label="Nome / Razão Social do Devedor:"
                        label-for="devedor"
                        class="text-label" >
                    <b-form-input
                            type="text"
                            id="devedor"
                            v-model="devedorLista.nome"
                            disabled
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="2">
                <b-form-group
                        label="Cota:"
                        label-for="variacao"
                        class="text-label required">
                    <b-form-input v-model="devedorLista.cota" type="text"
                                  @keyup="devedorLista.cota = formatarDecimal(devedorLista.cota, 3, 3)"
                                  :class="!validations.cota.valid ? 'is-invalid' : ''"/>
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-4" style="margin-left: -15px;">
                <b-button
                        class="icon-button"
                        title="Abrir Cadastro do Devedor"
                        variant="outline-primary"
                        @click="abrirModalDevedor(devedorLista)">
                    <i class="far fa-address-book fa-flip-horizontal vertical-middle"></i>
                </b-button>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="2">
                <b-form-group
                        label="CPF / CNPJ do Devedor:"
                        label-for="cpf"
                        class="text-label required">
                    <b-form-input
                            :disabled="requisicao.codRequisicaoRepresentacaoJudicial != null"
                            type="text"
                            id="num-documento"
                            data-vv-as="CPF"
                            v-model="devedor.cpfCnpj"
                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                            @change="buscarDevedor();limparCamposPagamento();"
                            :class="!validations.cpf.valid ? 'is-invalid' : ''"
                    ></b-form-input>
                    <div v-if="!validations.cpf.valid" class="invalid-message">{{ validations.cpf.message }}</div>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                        label="Nome / Razão Social do Devedor:"
                        label-for="devedor"
                        class="text-label required" >
                    <b-form-input
                            type="text"
                            id="devedor"
                            v-model="devedor.nome"
                            :disabled="devedor.codDevedor != null"
                            data-vv-as="devedor"
                            description="Devedor"
                            @change="limparCamposPagamento();"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="2" v-if="devedores.length > 0">
                <b-form-group
                        label="Cota:"
                        label-for="variacao"
                        class="text-label required">
                    <b-form-input v-model="devedor.cota" type="text"
                                  @keyup="devedor.cota = formatarDecimal(devedor.cota, 3, 3)"
                                  :class="!validations.cota.valid ? 'is-invalid' : ''"/>
                    <div v-if="!validations.cota.valid" class="invalid-message">A soma das cotas deve ser 100!</div>
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-4" style="margin-left: -15px;">
                <b-button
                        class="icon-button"
                        title="Abrir Cadastro do Devedor"
                        variant="outline-primary"
                        @click="abrirModalDevedor(devedor)">
                    <i class="far fa-address-book fa-flip-horizontal vertical-middle"></i>
                </b-button>
                <b-button v-if="devedores.length > 0"
                          id="removerDevedor"
                          class="icon-button"
                          title="Excluir Codevedor"
                          variant="outline-danger"
                          style="font-weight: 600;"
                          @click="excluirDevedor()">
                    <i class="fa fa-times-circle fa-flip-horizontal vertical-middle"></i>
                </b-button>
                <b-button v-if="requisicao.codRequisicaoRepresentacaoJudicial == null"
                        id="adicionarDevedor"
                        class="icon-button"
                        title="Adicionar Codevedor"
                        variant="outline-success"
                        style="font-weight: 600;"
                        @click="adicionarDevedor()">
                    <i class="fa fa-plus-circle fa-flip-horizontal vertical-middle"></i>
                </b-button>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="mb-0">
            <b-col sm="12" md="3">
                <p class="mb-0">
                    Escolha uma das Regras de Cálculo:
                    <span class="text-danger">*</span>
                </p>
                <b-form-group label>
                    <b-form-radio-group
                            id="radio-group"
                            v-model="requisicao.honorarioFixo"
                            :class="'radio-filter ' + (!validations.honorarioFixo.valid ? 'is-invalid' : '')"
                            class="radio-filter"
                            @change="reiniciarValores(); limparCamposPagamento();reiniciarValidacaoValor()">
                        <b-form-radio :value="true">
                            Honorários em Valor Fixo
                        </b-form-radio>
                        <b-form-radio :value="false">
                            Honorários sobre Base de Cálculo
                        </b-form-radio>
                    </b-form-radio-group>
                    <div v-if="!validations.honorarioFixo.valid" class="invalid-message">{{ validations.honorarioFixo.message }}</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="requisicao.honorarioFixo == true">
                <b-form-group
                        label="Valor Fixo (R$):"
                        label-for="valorFixo"
                        class="text-label required">
                    <b-form-input v-model="requisicao.valorFixo" type="text" id="valorFixo"
                                  @keyup="requisicao.valorFixo = formatarMonetario(requisicao.valorFixo)"
                                  :class="!validationsPrincipal.valor.valid || !validations.valorFixo.valid ? 'is-invalid' : ''"
                                  @change="executarCalculos(); limparCamposPagamento();validarValor()"></b-form-input>
                    <div v-if="!validationsPrincipal.valor.valid" class="invalid-message">Não é permitida a emissão de Requisição de valor zero ou negativo.</div>
                    <div v-if="validationsPrincipal.valor.valid && !validations.valorFixo.valid" class="invalid-message">{{validations.valorFixo.message}}</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="requisicao.honorarioFixo == false">
                <b-form-group
                        label="Valor da Base de Cálculo (R$):"
                        label-for="valorFixo"
                        class="text-label required">
                    <b-form-input v-model="requisicao.valorBaseCalculo" type="text" id="valorFixo"
                                  :class="!validationsPrincipal.valor.valid || !validations.valorBaseCalculo.valid ? 'is-invalid' : ''"
                                  @keyup="requisicao.valorBaseCalculo = formatarMonetario(requisicao.valorBaseCalculo)"
                                  @change="executarCalculos(); limparCamposPagamento();validarValor()"></b-form-input>
                    <div v-if="!validationsPrincipal.valor.valid" class="invalid-message">Não é permitida a emissão de Requisição de valor zero ou negativo.</div>
                    <div v-if="validationsPrincipal.valor.valid && !validations.valorBaseCalculo.valid" class="invalid-message">{{validations.valorBaseCalculo.message}}</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2" v-if="requisicao.honorarioFixo == false">
                <p class="mb-0">
                    Percentual:
                    <span class="text-danger">*</span>
                </p>
                <b-form-group label>
                    <b-form-radio-group
                            id="radio-group-percentual"
                            v-model="requisicao.percentual"
                            class="radio-filter"
                            @input="alterarTipoPercentual(); limparCamposPagamento();">
                        <b-form-radio :value="true">
                            Art. 85 do CPC
                        </b-form-radio>
                        <b-form-radio :value="false">
                            Percentual fixo
                        </b-form-radio>
                    </b-form-radio-group>
                    <div v-if="!validations.percentual.valid" class="invalid-message">{{ validations.percentual.message }}</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="requisicao.honorarioFixo == false && (requisicao.percentual != null && requisicao.percentual == false)">
                <b-form-group
                        label="Índice (%):"
                        label-for="variacao" @change="executarCalculos(); limparCamposPagamento();"
                        class="text-label required">
                    <b-form-input v-model="requisicao.valorIndice" type="text" @change="limparCamposPagamento();validarIndice();"
                                  :class="!validations.indice.valid ? 'is-invalid' : ''"
                                  @keyup="requisicao.valorIndice = formatarDecimalPositivo(requisicao.valorIndice, 3, 3)"
                    />
                    <div v-if="!validations.indice.valid" class="invalid-message">{{ validations.indice.message }}</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="requisicao.honorarioFixo == false && (requisicao.percentual != null && requisicao.percentual == true)">
                <b-button class="mt-4 btn-link" variant="outline-info" @click="abrirModalArtigo85()">
                    <i class="fa fa-pen"></i>  Informar as regras do Artigo 85 do CPC
                </b-button>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="mt-0">
            <b-col sm="12" md="12" lg="12" xl="8">
                <b-row class="mt-0">
                    <b-col sm="12" md="4">
                        <b-form-group
                                label="Índice de Correção:"
                                label-for="valorindica"
                                class="text-label">
                            <b-form-select v-model="requisicao.indiceCorrecao" class="mb-3" @change="limparCamposCorrecao();obterValoresCorrecao(); limparCamposPagamento(); alterarMinDataCorrecao();">
                                <template v-slot:first>
                                    <option :value="null">Selecionar</option>
                                </template>
                                <option
                                        v-for="tc in dados.indiceCorrecao"
                                        :key="tc.codIndice"
                                        :value="tc.codIndice">
                                    {{ tc.descricao }}
                                </option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <span>
                            Início da Correção
                        </span>
                        <vue-monthly-picker ref="inicioCorrecao" :monthLabels="meses" dateFormat="MM/YYYY" :min="minDataCorrecao" :max="maxDataCorrecao" placeHolder="mm/aaaa"
                                            :disabled="requisicao.indiceCorrecao == null"
                                            :inputClass="'month-year-display input ' + (!validations.inicioCorrecao.valid ? 'invalid-border ' : ' ')
                                                + (requisicao.indiceCorrecao == null ? 'disabled-date' : '')"
                                            v-model="requisicao.inicioCorrecao" @selected="obterValoresCorrecao(); limparCamposPagamento();">
                        </vue-monthly-picker>
                        <div v-if="!validations.inicioCorrecao.valid" class="invalid-message">{{ validations.inicioCorrecao.message }}</div>
                    </b-col>
                    <b-col sm="12" md="4">
                        <span>
                            Fim da Correção
                        </span>
                        <vue-monthly-picker :monthLabels="meses" dateFormat="MM/YYYY" :min="minDataFimCorrecao" :max="maxDataFimCorrecao" placeHolder="mm/aaaa"
                                            :disabled="requisicao.indiceCorrecao == null || requisicao.inicioCorrecao == null"
                                            :inputClass="'month-year-display input ' + (!validations.fimCorrecao.valid ? 'invalid-border ' : ' ')
                                                + (requisicao.indiceCorrecao == null || requisicao.inicioCorrecao == null ? 'disabled-date' : '')"
                                            v-model="requisicao.fimCorrecao" @selected="validarDataCorrecao(); obterValoresCorrecao(); limparCamposPagamento();">
                        </vue-monthly-picker>
                        <div v-if="!validations.fimCorrecao.valid" class="invalid-message">{{ validations.fimCorrecao.message }}</div>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col sm="12" md="4">
                        <b-form-group
                                label="Índice de Juros:"
                                label-for="valorindica"
                                class="text-label">
                            <b-form-select v-model="requisicao.indiceJuros" class="mb-3" @change="limparCamposJuros();obterValoresJuros(); limparCamposPagamento(); alterarMinDataJuros();">
                                <template v-slot:first>
                                    <option :value="null">Selecionar</option>
                                </template>
                                <option
                                        v-for="tc in dados.indiceJuros"
                                        :key="tc.codIndice"
                                        :value="tc.codIndice">
                                    {{ tc.descricao }}
                                </option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <span>
                            Início dos Juros
                        </span>
                        <vue-monthly-picker :monthLabels="meses" dateFormat="MM/YYYY" :min="minDataJuros" :max="maxDataJuros" placeHolder="mm/aaaa"
                                            :disabled="requisicao.indiceJuros == null"
                                            :inputClass="'month-year-display input ' + (!validations.inicioJuros.valid ? 'invalid-border ' : ' ')
                                                + (requisicao.indiceJuros == null ? 'disabled-date' : '')"
                                            v-model="requisicao.inicioJuros" @selected="obterValoresJuros(); limparCamposPagamento();">
                        </vue-monthly-picker>
                        <div v-if="!validations.inicioJuros.valid" class="invalid-message">{{ validations.inicioJuros.message }}</div>
                    </b-col>
                    <b-col sm="12" md="4">
                        <span>
                            Fim dos Juros
                        </span>
                        <vue-monthly-picker :monthLabels="meses" dateFormat="MM/YYYY" :min="minDataFimJuros" :max="maxDataFimJuros" placeHolder="mm/aaaa"
                                            :disabled="requisicao.indiceJuros == null || requisicao.inicioJuros == null"
                                            :inputClass="'month-year-display input ' + (!validations.fimJuros.valid ? 'invalid-border ' : ' ')
                                                + (requisicao.indiceJuros == null || requisicao.inicioJuros == null ? 'disabled-date' : '')"
                                            v-model="requisicao.fimJuros" @selected="validarDataJuros(); obterValoresJuros(); limparCamposPagamento();">
                        </vue-monthly-picker>
                        <div v-if="!validations.fimJuros.valid" class="invalid-message">{{ validations.fimJuros.message }}</div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col sm="12" md="12" lg="12" xl="4" class="mt-4">
                <b-form-group>
                    <b-form-checkbox v-model="requisicao.multaArtCpc" id="multaArtCpc" name="check-button" @input="executarCalculos(); limparCamposPagamento();">
                        Multa 10% do art.523/CPC
                    </b-form-checkbox>
                    <b-form-checkbox v-model="requisicao.honorariosArtCpc" id="honorariosArtCpc" name="check-button" @input="executarCalculos(); limparCamposPagamento();">
                        Honorários 10% do art.523/CPC
                    </b-form-checkbox>
                    <b-form-checkbox v-model="requisicao.deduzirPagamentos" id="deduzirPagamentos" name="check-button" class="mt-2" switch
                                     :disabled="!possuiQuitadasRescindidas()"
                                     @input="iniciarDeducoes()" style="float: left;">
                        Deduzir pagamento(s) anterior(es)
                    </b-form-checkbox>
                </b-form-group>
            </b-col>
        </b-row>
        <b-modal
                ref="modal-deduzir"
                id="modal-deduzir"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title='Cuidados ao utilizar a função "Deduzir pagamento(s) anterior(es)"'
                header-bg-variant="info"
                header-text-variant="white"
                @close="fecharModalAvisoDeducoes"
                @hide="fecharModalAvisoDeducoes">
	        <p>A opção "Deduzir pagamento(s) anterior(es)" ligada fará com que valores pagos em Requisições anteriores registradas no sistema, quitadas ou rescindidas (que indicam pagamento total ou parcial), em que conste a CDA selecionada, sejam deduzidos do cálculo de honorários.</p>
	        <p>Contudo, quando a geração de uma nova Requisição com a opção "Deduzir pagamento(s) anterior(es)" ligada puder ou tiver que recuperar e utilizar guias geradas no antigo sistema de Guias do Fundo, em razão da enorme quantidade de inconsistências geradas ao longo dos anos na alimentação do antigo sistema, RECOMENDA-SE ao usuário a realização ou a conferência do cálculo de deduções visto que, exatamente em razão das incongruências da base de dados apontadas, pagamentos realizados no sistema antigo PODEM NÃO SER RECONHECIDOS pelo SFEPGE, especialmente devido a:</p>
	        <p>- geração de guia no antigo sistema sem as informações necessárias para a correta vinculação no SFEPGE;</p>
	        <p>- geração de guia no antigo sistema com informações erradas;</p>
	        <p>- geração de guia no antigo sistema sem o apontamento de uma ou de todas as CDAs que integram aquela guia;</p>
	        <p>- geração de guia no antigo sistema sem o valores base das CDAs ao tempo da geração da guia;</p>
	        <p>- etc.</p>
	        <p>Todos esses problemas prejudicam ou impossibilitam a correta identificação e a vinculação da guia gerada no antigo sistema, assim demandando a pesquisa e a conferência manual por parte do usuário do SFEPGE ao utilizar a funcionalidade "Deduzir pagamento(s) anterior(es)".</p>

	        <template v-slot:modal-footer="{ hide }">
		        <b-button variant="primary" @click="hide('modal-deduzir')"> Ciente e continuar com o cálculo de dedução</b-button>
	        </template>
        </b-modal>

        <hr class="mt-4"/>

        <b-row class="mb-0">
            <b-col sm="12" md="2">
                <p class="mb-0">
                    Tipo de Pagamento:
                    <span class="text-danger">*</span>
                </p>
                <b-form-group label>
                    <b-form-select v-model="requisicao.pagamento" 
                                    @change="mudarPagamento(false);obterQuantidadeParcelas();listarFormaPagamentoPorTipo();"
                                   :class="!validations.tipoPagamentoParcela.valid || !validations.pagamento.valid ? 'invalid-select' : ''">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                                v-for="tc in regrasPagamento"
                                :key="tc.codPagamento"
                                :value="tc">
                            {{ tc.descricao }}
                        </option>
                    </b-form-select>
                    <div v-if="validations.tipoPagamentoParcela.valid && validations.tipoPagamento.valid && !validations.pagamento.valid" class="invalid-message">{{validations.pagamento.message}}</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2" v-if="requisicao.tipoPagamento == 1 && validations.tipoPagamentoParcela.valid && requisicao.pagamento && requisicao.pagamento.parcelas">
                <b-form-group
                        label="Escolha o número de Parcelas:"
                        label-for="numeroParcelas"
                        class="text-label required">
                    <b-form-select v-model="requisicao.numeroParcelas"
                                   :class="(!validations.numeroParcelas.valid ? 'invalid-select' : '')">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                                v-for="tc in dados.parcelas"
                                :key="tc.id"
                                :value="tc.id">
                            {{ tc.text }}
                        </option>
                    </b-form-select>
                    <div v-if="!validations.numeroParcelas.valid" class="invalid-message">{{validations.numeroParcelas.message}}</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2" v-if="requisicao.tipoPagamento == 1 && validations.tipoPagamentoParcela.valid && requisicao.pagamento && !requisicao.pagamento.parcelas">
                <b-form-group
                        label="Informe o Número de Parcelas:"
                        label-for="valorFixo"
                        class="text-label required">
                    <b-form-input v-model="requisicao.numeroParcelasFixo" type="text" id="valorFixo"
                                  :class="(!validations.numeroParcelasFixo.valid ? 'is-invalid' : '')"
                                  @keyup="requisicao.numeroParcelasFixo = formatarDecimal(requisicao.numeroParcelasFixo, 3, 0)"></b-form-input>
                    <div v-if="!validations.numeroParcelasFixo.valid" class="invalid-message">{{validations.numeroParcelasFixo.message}}</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="requisicao.tipoPagamento == 1 && validations.tipoPagamentoParcela.valid">
                <b-form-group
                        label="Escolha o Índice de Reajuste das Parcela:"
                        label-for="valorindica"
                        class="text-label required">
                    <b-form-select v-model="requisicao.indiceReajuste"
                                   :class="'mb-3 ' + (!validations.indiceReajuste.valid ? 'invalid-select' : '')">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                                v-for="tc in dados.indiceReajuste"
                                :key="tc.codIndice"
                                :value="tc.codIndice">
                            {{ tc.descricao }}
                        </option>
                    </b-form-select>
                    <div v-if="!validations.indiceReajuste.valid" class="invalid-message">{{validations.indiceReajuste.message}}</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group
                        label="Forma de Pagamento:"
                        label-for="formapagamento"
                        class="text-label required">

                    <b-form-select 
                            v-model="requisicao.formaPagamento"
                            :options="formaPagamentoLista"
                            @input="executarCalculos()"
                            @change="executarCalculos()"
                            :disabled="formaPagamentoLista.length == 1"
                            :class="(!validations.formaPagamento.valid ? 'invalid-select' : '')">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                    </b-form-select>
                    <div v-if="!validations.formaPagamento.valid" class="invalid-message">{{validations.formaPagamento.message}}</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2" v-if="requisicao.tipoPagamento == 0 && requisicao.formaPagamento == 2">
                <b-form-group
                        label="Data Transferência:"
                        label-for="dataTransferencia"
                        class="text-label required">
                    <b-form-input
                            v-model="requisicao.dataTransferencia"
                            id="dataTransferencia"
                            max="9999-12-31"
                            name="dataTransferencia"
                            type="date"
                            :class="!validations.dataTransferencia.valid ? 'is-invalid' : ''"/>
                    <div v-if="!validations.dataTransferencia.valid" class="invalid-message">A data inserida é inválida!</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="12">
                <div v-if="!validations.tipoPagamentoParcela.valid && validations.tipoPagamento.valid" class="invalid-message">O valor dos honorários é inferior ao valor mínimo da parcela previsto para a regra de parcelamento escolhida! Para gerar a requisição para este valor de honorários, selecione outra regra de parcelamento disponível ou selecione o tipo de pagamento à vista!</div>
                <div v-if="!validations.tipoPagamento.valid" class="invalid-message">A Regra de Pagamento não se encontra válida!</div>
            </b-col>
        </b-row>

        <b-row class="mt-3" v-if="requisicao.tipoPagamento == 1 && validations.tipoPagamentoParcela.valid && requisicao.pagamento && requisicao.pagamento.delibSid">
            <b-col sm="12" md="2">
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group
                        label="Nº Deliberação Conselho:"
                        label-for="valorindica"
                        class="text-label required">
                    <b-form-input v-model="requisicao.deliberacao" type="text" maxlength="50" id="valorFixo"
                                  :class="!validations.deliberacao.valid ? 'is-invalid' : ''"/>
                    <div v-if="!validations.deliberacao.valid" class="invalid-message">{{validations.deliberacao.message}}</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group
                        label="SID:"
                        label-for="valorindica"
                        class="text-label required">
                    <b-form-input v-model="requisicao.sid" type="text" maxlength="50" id="valorFixo"
                                  :class="!validations.sid.valid ? 'is-invalid' : ''"/>
                    <div v-if="!validations.sid.valid" class="invalid-message">{{validations.sid.message}}</div>
                </b-form-group>
            </b-col>
        </b-row>

        <b-modal
                ref="modal-regras"
                id="modal-regras"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Informar as regras do Artigo 85 do CPC"
                header-bg-variant="success"
                header-text-variant="white">
            <b-col xs="12" md="12" class="mx-auto">
                <div id="messages" v-if="messageModal.message !== null">
                    <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
                </div>
            </b-col>
            <b-row class="mt-3">
                <b-col>
                    <label for="dataSentenca">
                        Data da sentença líquida ou da decisão de liquidação (art.85, §4º, IV, CPC):
                        <span class="text-danger">*</span>
                    </label>
                    <b-input style="width: 200px;" v-model="requisicao.dataSentenca" id="dataSentenca" type="date"
                             :class="!validations.dataSalarioMinimo.valid ? 'is-invalid' : ''"
                             max="9999-12-31"
                             @change="obterSalarioMinimo(false)"
                             @blur="validarDataSalarioMinimo()"></b-input>
                    <div v-if="!validations.dataSalarioMinimo.valid" class="invalid-message">Data inválida!</div>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col sm="12" md="4">
                    <b-form-group
                            label="Salário Mínimo Vigente (R$):"
                            label-for="salarioMinimo"
                            class="text-label required">
                        <b-form-input v-model="requisicao.salarioMinimo" type="text" id="salarioMinimo" disabled
                                      @keyup="requisicao.salarioMinimo = formatarMonetario(requisicao.salarioMinimo)"
                                      @change="quantidadeSalarios();limparCamposPagamento();"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group
                            label="Base de Cálculo em quantidade de Salários Mínimos:"
                            label-for="quantidadeSalarios"
                            class="text-label required">
                        <b-form-input v-model="requisicao.quantidadeSalarios" readonly id="quantidadeSalarios"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <p class="mt-4">Faixas (art.85, §4º, IV, CPC)</p>
            <b-table
                    :items="faixas"
                    :fields="fieldsFaixasArt85"
                    striped
                    small
                    responsive
                    :busy="false"
                    show-empty
                    hover
                    bordered
                    sort-icon-left
                    class="mb-0"
                    head-variant="light">
                <div slot="table-busy" class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
                <template v-slot:cell(percentual)="{ item }">
                    <p v-if="!item.informar">-</p>
                    <b-form-input v-if="item.informar" v-model="item.percentual" type="text" :ref="'faixa' + item.percentualMinimo" @change="limparCamposPagamento()"
                                  @keyup="item.percentual = formatarDecimal(item.percentual, 2, 2)" @blur="validarFaixa(item.percentualMinimo)"/>
                </template>
                <template v-slot:cell(baseIncidencia)="{ item }">
                    <p v-if="!item.informar">-</p>
                    <p v-if="item.informar" class="text-right">
                        {{ item.baseIncidencia | currency }}
                    </p>
                </template>
                <template v-slot:cell(valorHonorarios)="{ item }">
                    <p v-if="!item.informar">-</p>
                    <p v-if="item.informar && item.percentual != null && item.percentual != ''" class="text-right">
                        {{ obterValorItem(item) | currency }}
                    </p>
                </template>
                <template slot="bottom-row" slot-scope="data" >
                    <td v-for="(field, i) in data.fields">
                        <p v-if="i == 2">
                            <b>Total:</b>
                        </p>
                        <p class="text-right" v-if="i == 3">
                            {{ totalBaseIncidencia() | currency }}
                        </p>
                        <p class="text-right" v-if="i == 4">
                            {{ totalValorHonorario() | currency }}
                        </p>
                    </td>
                </template>
            </b-table>

            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="cancelarRegras"> <i class="fa fa-times"></i> Cancelar</b-button>
                <b-button variant="primary" @click="salvarRegras()" :disabled="!regrasValidas()" class="mr-2"> <i class="far fa-save"></i> Salvar</b-button>
            </template>
        </b-modal>

        <b-modal
                ref="modal-datas"
                id="modal-datas"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Datas de Correção"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Não foram indicadas as datas Início da Correção e Fim da Correção. Ao clicar no botão Próxima, essa configuração fará com que os pagamentos anteriores sejam atualizados, mas não sofrerá atualização o valor de honorários informados (Honorários em Valor Fixo) ou calculados (Honorários sobre Base de Cálculo). Para atualizar também os honorários informados ou calculados, clique no botão Preencher Datas e preencha os campos Início da Correção e Fim da Correção.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="outline-primary" @click="preencherDataCorrecao" class="mr-2"> <i class="far fa-calendar-alt"></i> Preencher Datas</b-button>
                <b-button variant="outline-secondary" @click="hide('modal-datas')"> <i class="fas fa-arrow-right"></i> Prosseguir</b-button>
            </template>
        </b-modal>

        <CompLoading ref="loading"/>
        <ModalIncluirDevedor
            ref="modalDevedor"
            @novoDevedor="novoDevedor"
            @cancelarNovoDevedor="cancelarNovoDevedor" />
        <ModalAlterarDevedor
                ref="modalAlterarDevedor"
                :loading="$refs.loading"
                @salvarDevedor="salvarDevedor"/>
    </div>
</template>

<script>
    import Vue from 'vue';
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompLoading from "../../shared/components/CompLoading";
    import ModalIncluirDevedor from "../../shared/components/ModalIncluirDevedor";
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";
    import VueMonthlyPicker from 'vue-monthly-picker';
    import moment from 'moment';

    export default {
        props: ['cnj', 'selecteds','devedores', 'listaContribuintes', 'devedor','requisicao','items','faixas','regrasPagamento','validationsPrincipal'],
        mixins: [ formatarMixins ],
        watch: {
            tipoPagamento() {
                return this.requisicao.tipoPagamento;
            },
            'requisicao.pagamento'() {
                
                // Validação extra: ainda não populou a combo forma de pagamento e não foi selecionada nenhuma forma de pagamento
                if (!this.requisicao.formaPagamento) {
                    this.listarFormaPagamentoPorTipo();
                }
            }
        },
        components: {CompLoading, ModalIncluirDevedor, ModalAlterarDevedor, VueMonthlyPicker},
        data() {
            return {
                urlApi: null,
                token: null,
                faixasTemp: null,
                dataSentencaTemp: null,
                salarioMinimoTemp: null,
                quantidadeSalariosTemp: null,
                devedorAtual: null,
                dados: {
                    indiceCorrecao: [],
                    indiceJuros: [],
                    indiceReajuste: [],
                    formasPagamento: [],
                    parcelas: [],
                },
                fieldsFaixasArt85: [
                    {
                        key: 'descricao',
                        label: 'Faixa'
                    },
                    {
                        key: 'percentual',
                        label: 'Percentuais Fixados'
                    },
                    {
                        key: 'faixa',
                        label: 'Faixas em SMs'
                    },
                    {
                        key: 'baseIncidencia',
                        label: 'Base de Incidência (R$)'
                    },
                    {
                        key: 'valorHonorarios',
                        label: 'Valor Honorários (R$)'
                    }
                ],
                valoresCorrecao: [],
                valoresJuros: [],
                meses: [
                    'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
                ],
                minDataCorrecao: null,
                maxDataCorrecao: null,
                minDataFimCorrecao: null,
                maxDataFimCorrecao: null,
                minDataJuros: null,
                maxDataJuros: null,
                minDataFimJuros: null,
                maxDataFimJuros: null,
                messageModal: {
                    message: null,
                    variant: null
                },
                validations: {
                    tipoPagamentoParcela: { valid: true },
                    tipoPagamento: { valid: true },
                    cota: { valid: true },
                    cpf: { valid: true, message: '' },
                    dataTransferencia: { valid: true },
                    indice: { valid: true, message: '' },
                    fimCorrecao: { valid: true, message: '' },
                    inicioCorrecao: { valid: true, message: '' },
                    fimJuros: { valid: true, message: '' },
                    inicioJuros: { valid: true, message: '' },
                    honorarioFixo: { valid: true, message: '' },
                    valorFixo: { valid: true, message: '' },
                    percentual: { valid: true, message: '' },
                    valorBaseCalculo: { valid: true, message: '' },
                    pagamento: { valid: true, message: '' },
                    formaPagamento: { valid: true, message: '' },
                    indiceReajuste: { valid: true, message: '' },
                    numeroParcelas: { valid: true, message: '' },
                    numeroParcelasFixo: { valid: true, message: '' },
                    deliberacao: { valid: true, message: '' },
                    sid: { valid: true, message: '' },
                    dataSalarioMinimo: { valid: true }
                },

                formaPagamentoLista: []
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            adicionarDevedor() {
                this.$store.commit("setMessages", {});

                if(this.devedor.codDevedor == null) {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [{
                            message: 'Informe um devedor existente ou inclua um novo'
                        }]});
                    return;
                }

                this.devedores.push({
                    ...this.devedor,
                    ordem: (this.devedores.length == 0 ? 0 : this.devedores[this.devedores.length - 1].ordem + 1)
                });

                this.$emit('limparDevedor');

                this.limparCamposPagamento();
            },
            excluirDevedor() {
                this.$emit('excluirDevedor');

                this.excluirDevedorListaContribuintes();

                this.limparCamposPagamento();
            },
            excluirDevedorListaContribuintes () {
                let indexUltimoContribuinte = this.listaContribuintes.length - 1;
                this.contribuinte = {
                    ...this.listaContribuintes[indexUltimoContribuinte]
                };
                this.listaContribuintes.splice(indexUltimoContribuinte, 1);
            },
            async buscarDevedor() {
                this.$store.commit("setMessages", {});

                if(this.devedor.cpfCnpj.length <= 14 && !this.validarCpf(this.devedor.cpfCnpj)) {
                    this.validations.cpf.valid = false;
                    this.validations.cpf.message = 'CPF inválido.';
                    this.devedor.codDevedor = null;
                    this.devedor.nome = null;
                    return;
                } else if(this.devedor.cpfCnpj.length > 14 && !this.validarCnpj(this.devedor.cpfCnpj)) {
                    this.validations.cpf.valid = false;
                    this.validations.cpf.message = 'CNPJ inválido.';
                    this.devedor.codDevedor = null;
                    this.devedor.nome = null;
                    return;
                }

                if(this.devedores.length > 0) {
                    for(var i = 0; i < this.devedores.length; i++) {
                        if(this.devedor.cpfCnpj == this.devedores[i].cpfCnpj) {
                            this.validations.cpf.valid = false;
                            this.validations.cpf.message = 'CPF/CNPJ já incluído!';
                            this.devedor.codDevedor = null;
                            this.devedor.nome = null;
                            return;
                        }
                    }
                }
                this.validations.cpf.valid = true;

                let devedor = {
                    documento: this.devedor.cpfCnpj
                };

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/receitasDiversas/obterContribuinte`, devedor, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(response.data != null && response.data != "") {
                        
                        this.devedor.codDevedor = response.data.codContribuinte;
                        this.devedor.nome = response.data.nome;
                        this.devedor.email = response.data.email;
                        this.devedor.emailAlternativo1 = response.data.emailAlternativo1;
                        this.devedor.emailAlternativo2 = response.data.emailAlternativo2;

                        const novoDevedor = {
                            codDevedor: response.data.codContribuinte,
                            nome: response.data.nome,
                            email: response.data.email,
                            emailAlternativo1: response.data.emailAlternativo1,
                            emailAlternativo2: response.data.emailAlternativo2,
                            ordem: 0 // Defina a ordem inicial aqui, se necessário
                        };

                        // Verifica se o novoDevedor já existe na listaContribuintes
                        const existeContribuinte = this.listaContribuintes.some(devedor => devedor.codDevedor === novoDevedor.codDevedor);

                        if (this.devedores.length === 0) {
                            if (this.listaContribuintes.length > 0) {
                                // Já existe um item na listaContribuintes, então altera o item existente para o devedor informado
                                Object.assign(this.listaContribuintes[0], { ...novoDevedor, ordem: this.listaContribuintes[0].ordem });
                            } else if (!existeContribuinte) {
                                // Não existe um item na listaContribuintes, então inclui o novoDevedor com push
                                this.listaContribuintes.push(novoDevedor);
                            }
                        } else if (this.devedores.length > 0) {
                            
                            const ultimoContribuinte = this.listaContribuintes[this.listaContribuintes.length - 1];
                            const novaOrdem = ultimoContribuinte.ordem + 1;
                            const ordensIguais = this.devedores.some(devedor => devedor.ordem === ultimoContribuinte.ordem);

                            if (ordensIguais) {
                                this.listaContribuintes.push({ ...novoDevedor, ordem: novaOrdem });
                            } else {
                                Object.assign(this.listaContribuintes[this.listaContribuintes.length - 1], { ...novoDevedor, ordem: ultimoContribuinte.ordem });
                            }
                        }

                    } else {
                        this.devedor.codDevedor = null;
                        this.devedor.nome = null;
                        this.$refs.modalDevedor.abrirModalIncluirDevedorCpf(this.devedor.cpfCnpj);
                    }
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                })
            },
            abrirModalDevedor(devedor) {
                if(devedor.codDevedor != null) {
                    this.devedorAtual = devedor;
                    this.$refs.modalAlterarDevedor.carregarCadastro(devedor.codDevedor);
                } else {
                    this.$refs.modalDevedor.abrirModalDevedor({ modalTitulo: 'Cadastro do Devedor' });
                }
            },
            validarDataSalarioMinimo() {
                if(!moment(this.requisicao.dataSentenca).isValid()) {
                    this.validations.dataSalarioMinimo.valid = false;
                } else {
                    this.validations.dataSalarioMinimo.valid = true;
                    this.obterSalarioMinimo(true);
                }
            },
            async obterSalarioMinimo(forcar) {
                this.messageModal.message = null;
                if(this.requisicao.dataSentenca != null && this.requisicao.dataSentenca != "") {
                    let anoFinal = parseInt(this.requisicao.dataSentenca.split('-')[0]);

                    if(!forcar && anoFinal < 1900) {
                        return;
                    }

                    this.$refs.loading.showLoading();
                    axios.post(`${this.urlApi}/v1/honorariosAcaoJudicial/salarioMinimo`, {dataSentenca: this.requisicao.dataSentenca}, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        if(response.data != null && response.data.valor != undefined) {
                            let salarioMinimo = (Math.round(response.data.valor * 100) / 100).toFixed(2).toString();
                            this.requisicao.salarioMinimo = this.formatarMonetario(salarioMinimo);
                            this.quantidadeSalarios();
                        } else {
                            this.messageModal = {
                                message: 'Não existe valor do salário mínimo para a data vigente.',
                                variant: 'danger'
                            };
                            this.requisicao.salarioMinimo = null;
                            this.quantidadeSalarios();
                        }
                    }).finally(() => {
                        this.$refs.loading.hideLoading();
                    })
                } else {
                    this.requisicao.salarioMinimo = null;
                    this.quantidadeSalarios();
                }
            },
            async quantidadeSalarios() {
                if(this.requisicao.valorBaseCalculo != null && this.requisicao.salarioMinimo != null) {
                    let valorBaseCalculoTemp = parseFloat(this.requisicao.valorBaseCalculo.toString().replace(/[^1234567890,]/g, "").replace(",", "."));
                    let salarioMinimoTemp = parseFloat(this.requisicao.salarioMinimo.toString().replace(/[^1234567890,]/g, "").replace(",", "."));

                    this.requisicao.quantidadeSalarios = 0.0;
                    while(valorBaseCalculoTemp > 0) {
                        if(valorBaseCalculoTemp > salarioMinimoTemp) {
                            this.requisicao.quantidadeSalarios += 1.0;
                            valorBaseCalculoTemp -= salarioMinimoTemp;
                        } else {
                            let valorPct = ((valorBaseCalculoTemp * 100) / salarioMinimoTemp) / 100;
                            if(valorPct < 0.005) {
                                valorPct = 0;
                            }
                            this.requisicao.quantidadeSalarios += valorPct;
                            valorBaseCalculoTemp = 0;
                        }
                    }

                    this.requisicao.quantidadeSalarios = (Math.round(this.requisicao.quantidadeSalarios * 100) / 100).toFixed(2);

                    let quantidade = this.requisicao.quantidadeSalarios;
                    let valorBaseRestante = this.requisicao.valorBaseCalculo.toString().replace(/[^1234567890,]/g, "").replace(",", ".");
                    for(var i = 0; i < this.faixas.length; i++) {
                        if(valorBaseRestante > 0) {
                            let maximo = this.faixas[i].numeroMaximoSalarios != null ?
                                (this.faixas[i].numeroMaximoSalarios - this.faixas[i].numeroMinimoSalarios) : 999999999;

                            if(quantidade >= maximo) {
                                this.faixas[i].baseIncidencia = salarioMinimoTemp * maximo;
                                valorBaseRestante -= this.faixas[i].baseIncidencia;
                                quantidade = quantidade - maximo;
                            } else {
                                this.faixas[i].baseIncidencia = valorBaseRestante;
                                quantidade = 0;
                                valorBaseRestante = 0;
                            }

                            this.faixas[i].informar = true;
                        } else {
                            this.faixas[i].informar = false;
                            this.faixas[i].baseIncidencia = null;
                            this.faixas[i].percentual = null;
                        }
                    }
                } else {
                    this.requisicao.quantidadeSalarios = null;

                    for(var i = 0; i < this.faixas.length; i++) {
                        this.faixas[i].informar = false;
                        this.faixas[i].baseIncidencia = null;
                        this.faixas[i].percentual = null;
                    }
                }
            },
            novoDevedor(contribuinte) {
                this.devedor.codDevedor = contribuinte.codContribuinte;
                this.devedor.nome = contribuinte.nome;
                this.devedor.cpfCnpj = contribuinte.documento;
                this.devedor.email = contribuinte.email;
                this.devedor.emailAlternativo1 = contribuinte.emailAlternativo1;
                this.devedor.emailAlternativo2 = contribuinte.emailAlternativo2;

                const novoDevedor = {
                    codDevedor: contribuinte.codContribuinte,
                    nome: contribuinte.nome,
                    email: contribuinte.email,
                    emailAlternativo1: contribuinte.emailAlternativo1,
                    emailAlternativo2: contribuinte.emailAlternativo2,
                    ordem: 0 // Defina a ordem inicial aqui, se necessário
                };

                // Verifica se o novoDevedor já existe na listaContribuintes
                const existeContribuinte = this.listaContribuintes.some(devedor => devedor.codDevedor === novoDevedor.codDevedor);

                if (this.devedores.length === 0) {
                    if (this.listaContribuintes.length > 0) {
                        // Já existe um item na listaContribuintes, então altera o item existente para o devedor informado
                        Object.assign(this.listaContribuintes[0], { ...novoDevedor, ordem: this.listaContribuintes[0].ordem });
                    } else if (!existeContribuinte) {
                        // Não existe um item na listaContribuintes, então inclui o novoDevedor com push
                        this.listaContribuintes.push(novoDevedor);
                    }
                } else if (this.devedores.length > 0) {
                    
                    const ultimoContribuinte = this.listaContribuintes[this.listaContribuintes.length - 1];
                    const novaOrdem = ultimoContribuinte.ordem + 1;
                    const ordensIguais = this.devedores.some(devedor => devedor.ordem === ultimoContribuinte.ordem);

                    if (ordensIguais) {
                        this.listaContribuintes.push({ ...novoDevedor, ordem: novaOrdem });
                    } else {
                        Object.assign(this.listaContribuintes[this.listaContribuintes.length - 1], { ...novoDevedor, ordem: ultimoContribuinte.ordem });
                    }
                }
    
            },
            salvarDevedor(devedorSalvo) {

                if(this.listaContribuintes.length > 0) {
                    for(var i = 0; i < this.listaContribuintes.length; i++) {
                        if(this.listaContribuintes[i].codDevedor == devedorSalvo.codContribuinte) {
                            this.listaContribuintes[i].email = devedorSalvo.email
                            this.listaContribuintes[i].emailAlternativo1 = devedorSalvo.emailAlternativo1
                            this.listaContribuintes[i].emailAlternativo2 = devedorSalvo.emailAlternativo2
                        }
                    }
                }

                this.devedor.email = devedorSalvo.email;
                this.devedor.emailAlternativo1 = devedorSalvo.emailAlternativo1;
                this.devedor.emailAlternativo2 = devedorSalvo.emailAlternativo2;
            },
            cancelarNovoDevedor() {
                this.devedor.codDevedor = null;
                this.devedor.nome = null;
                this.devedor.cpfCnpj = null;
            },
            async listarIndiceCorrecao() {
                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/listarIndiceCorrecao`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.indiceCorrecao = response.data;
                    this.alterarMinDataCorrecao();
                })
            },
            async listarIndiceJuros() {
                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/listarIndiceJuros`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.indiceJuros = response.data;
                    this.alterarMinDataJuros();
                })
            },
            async listarIndiceReajuste() {
                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/listarIndiceReajuste`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.indiceReajuste = response.data
                })
            },
            async listarFormaPagamento() {
                axios.get(`${this.urlApi}/v1/receitasDiversas/listarFormaPagamento`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.formasPagamento = response.data
                })
            },
            reiniciarValores() {
                if(this.requisicao.honorarioFixo == true) {
                    this.requisicao.valorBaseCalculo = null;
                    this.requisicao.valorHonorariosArtigo = null;
                    this.requisicao.percentual = null;
                    this.requisicao.valorIndice = null;
                } else if(this.requisicao.percentual == false) {
                    this.requisicao.valorFixo = null;
                } else {
                    this.requisicao.valorIndice = null;
                    this.requisicao.valorFixo = null;
                    this.requisicao.valorHonorariosArtigo = null;
                }
            },
            totalBaseIncidencia() {
                let total = null;
                for(var i = 0; i < this.faixas.length; i++) {
                    if(this.faixas[i].baseIncidencia != null) {
                        if(total == null) {
                            total = this.faixas[i].baseIncidencia;
                        } else {
                            total += this.faixas[i].baseIncidencia;
                        }
                    }
                }

                return total;
            },
            totalValorHonorario() {
                let total = null;
                for(var i = 0; i < this.faixas.length; i++) {
                    if(this.faixas[i].percentual != null && this.faixas[i].baseIncidencia != null) {
                        if(this.faixas[i].percentual == "" || this.faixas[i].percentual == null) {
                            continue;
                        }

                        let valorItem = ((this.faixas[i].baseIncidencia * parseFloat(this.tratarCamposNumericos(this.faixas[i].percentual))) / 100);
                        total = total == null ? valorItem : total += valorItem;
                    }
                }

                this.requisicao.valorHonorariosArtigo = total;

                return total;
            },
            multa() {
                if(this.requisicao.multaArtCpc && this.obterValorHonorarios() != null) {
                    let valor = parseFloat(this.obterValorHonorarios()) +
                        (this.requisicao.valorCorrecao != null ? this.requisicao.valorCorrecao : 0) +
                        (this.requisicao.valorJuros != null ? this.requisicao.valorJuros : 0) -
                        (this.requisicao.valoresAnteriores != null ? this.requisicao.valoresAnteriores : 0);

                    return valor * 0.1;
                }

                return null;
            },
            honorarios() {
                if(this.requisicao.honorariosArtCpc && this.obterValorHonorarios() != null) {
                    let valor = parseFloat(this.obterValorHonorarios()) +
                        (this.requisicao.valorCorrecao != null ? this.requisicao.valorCorrecao : 0) +
                        (this.requisicao.valorJuros != null ? this.requisicao.valorJuros : 0) -
                        (this.requisicao.valoresAnteriores != null ? this.requisicao.valoresAnteriores : 0);
                    return valor * 0.1;
                }

                return null;
            },
            obterQuantidadeParcelas() {
                this.validations.tipoPagamentoParcela.valid = true;
                this.validations.tipoPagamento.valid = true;
                this.dados.parcelas = [];
                if(this.requisicao.pagamento && !this.requisicao.pagamento.aVista && this.requisicao.pagamento.parcelas) {
                    let valorHonorarios = this.obterValorHonorarios();
                    if(valorHonorarios != null && valorHonorarios > 0) {
                        let valorTotal = parseFloat(valorHonorarios) +
                            (this.requisicao.valorCorrecao != null ? this.requisicao.valorCorrecao : 0) -
                            (this.requisicao.valoresAnteriores != null ? this.requisicao.valoresAnteriores : 0) +
                            (this.requisicao.valorJuros != null ? this.requisicao.valorJuros : 0) +
                            (this.multa() != null ? this.multa() : 0) +
                            (this.honorarios() != null ? this.honorarios() : 0);

                        axios.post(`${this.urlApi}/v1/honorariosAcaoJudicial/obterNumeroParcelas/${this.requisicao.pagamento.codPagamento}`, valorTotal, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': this.token
                            }
                        }).then(response => {
                            if(response.data != null && response.data.valido == false) {
                                this.validations.tipoPagamento.valid = false;
                                this.validations.tipoPagamentoParcela.valid = false;
                            }

                            if(response.data != null && response.data != "") {
                                this.requisicao.numeroMinimoParcelas = response.data.minimo;
                                this.requisicao.numeroMaximoParcelas = response.data.maximo;

                                let valorParcela = valorTotal;

                                for(var i = response.data.minimo; i <= response.data.maximo; i++) {
                                    let valorParcela = (valorTotal/i).toFixed(2);
                                    if(valorParcela >= response.data.valorMinimoParcela) {
                                        let valorParcelaString = (valorTotal/i).toFixed(2).toString().replace('.', ',');
                                        valorParcelaString =  valorParcela.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                                        this.dados.parcelas.push({
                                            id: i,
                                            text: i + ' X - R$ ' + valorParcelaString + ' + correção'
                                        });
                                    }
                                }
                            }

                            if(this.dados.parcelas.length == 0) {
                                this.validations.tipoPagamentoParcela.valid = false;
                            }
                        });
                    }
                } else if(this.requisicao.pagamento != null) {
                    axios.post(`${this.urlApi}/v1/honorariosAcaoJudicial/obterNumeroParcelas/${this.requisicao.pagamento.codPagamento}`, 0, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        if(response.data != null && response.data.valido == false) {
                            this.validations.tipoPagamento.valid = false;
                            this.validations.tipoPagamentoParcela.valid = false;
                        }
                    });
                }
            },
            limparCamposCorrecao() {
                this.requisicao.inicioCorrecao = null;
                this.requisicao.fimCorrecao = null;
            },
            limparCamposJuros() {
                this.requisicao.inicioJuros = null;
                this.requisicao.fimJuros = null;
            },
            obterValoresCorrecao() {
                this.valoresCorrecao = [];
                this.requisicao.modalDatas = false;
                if(this.requisicao.indiceCorrecao != null
                        && ((this.requisicao.inicioCorrecao != null && this.requisicao.inicioCorrecao._i != null)
                                || "string" == typeof this.requisicao.inicioCorrecao)
                        && ((this.requisicao.fimCorrecao != null && this.requisicao.fimCorrecao._i != null)
                                || "string" == typeof this.requisicao.fimCorrecao)) {
                    let valoresIndice = {
                        codIndice: this.requisicao.indiceCorrecao,
                        dataInicio: ("string" == typeof this.requisicao.inicioCorrecao ? this.requisicao.inicioCorrecao.replace("-", "/") : this.requisicao.inicioCorrecao._i),
                        dataFim: ("string" == typeof this.requisicao.fimCorrecao ? this.requisicao.fimCorrecao.replace("-", "/") : this.requisicao.fimCorrecao._i)
                    };

                    axios.post(`${this.urlApi}/v1/honorariosAcaoJudicial/obterValoresIndice`, valoresIndice, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        if(response.data != null && response.data != "") {
                            this.valoresCorrecao = response.data;
                            this.executarCalculos();
                        }
                    })
                }
            },
            obterValoresJuros() {
                this.valoresJuros = [];
                if(this.requisicao.indiceJuros != null
                        && ((this.requisicao.inicioJuros != null && this.requisicao.inicioJuros._i != null)
                            || "string" == typeof this.requisicao.inicioJuros)
                        && ((this.requisicao.fimJuros != null && this.requisicao.fimJuros._i != null)
                            || "string" == typeof this.requisicao.fimJuros)) {
                    let valoresIndice = {
                        codIndice: this.requisicao.indiceJuros,
                        dataInicio: ("string" == typeof this.requisicao.inicioJuros ? this.requisicao.inicioJuros.replace("-", "/") : this.requisicao.inicioJuros._i),
                        dataFim: ("string" == typeof this.requisicao.fimJuros ? this.requisicao.fimJuros.replace("-", "/") : this.requisicao.fimJuros._i)
                    };

                    axios.post(`${this.urlApi}/v1/honorariosAcaoJudicial/obterValoresIndice`, valoresIndice, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        if(response.data != null && response.data != "") {
                            this.valoresJuros = response.data;
                            this.executarCalculos();
                        }
                    })
                }
            },
            obterValorHonorarios() {
                let valorHonorarios = null;
                if(this.requisicao.honorarioFixo == true) {
                    if(this.requisicao.valorFixo != null) {
                        valorHonorarios = this.requisicao.valorFixo.toString().replace(/[^1234567890,]/g, "").replace(",", ".");
                    }
                } else if(this.requisicao.percentual == false) {
                    if(this.requisicao.valorBaseCalculo != null && this.requisicao.valorIndice != null) {
                        let valorBaseCalculoTemp = this.requisicao.valorBaseCalculo.toString().replace(/[^1234567890,]/g, "").replace(",", ".");
                        let valorIndiceTemp = this.requisicao.valorIndice.toString().replace(/[^1234567890,]/g, "").replace(",", ".");
                        valorHonorarios = (valorBaseCalculoTemp * valorIndiceTemp) / 100;
                    }
                } else {
                    valorHonorarios = this.requisicao.valorHonorariosArtigo;
                }
                return valorHonorarios;
            },
            async aplicarCorrecaoJuros() {
                let valorHonorarios = this.obterValorHonorarios();

                if(valorHonorarios != null && valorHonorarios > 0) {
                    this.requisicao.valorCorrecao = 0;
                    if(this.valoresCorrecao.length > 0) {
                        for(var i = 0; i < this.valoresCorrecao.length; i++) {
                            this.requisicao.valorCorrecao += (parseFloat(valorHonorarios) + this.requisicao.valorCorrecao) * (this.valoresCorrecao[i].variacao / 100);
                        }
                    }

                    this.requisicao.requisicoesDeducao = null;
                    this.requisicao.valoresAnteriores = null;
                    if(this.requisicao.deduzirPagamentos == true && this.requisicao.indiceCorrecao != null) {
                        let items = [];
                        if(this.selecteds.length > 0) {
                            for(var i = 0; i < this.selecteds.length; i++) {
                                items.push(this.selecteds[i]);
                            }
                        } else {
                            for(var i = 0; i < this.items.length; i++) {
                                if(this.items[i].situacao == 'Quitada' || this.items[i].situacao == 'Rescindido') {
                                    items.push(this.items[i]);
                                }
                            }
                        }

                        if(items.length > 0) {
                            await axios.post(`${this.urlApi}/v1/honorariosAcaoJudicial/obterValoresAnterioresAtualizado/` + this.requisicao.indiceCorrecao, items, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': this.token
                                }
                            }).then(response => {
                                this.requisicao.requisicoesDeducao = items;
                                this.requisicao.valoresAnteriores = response.data;
                            }).catch((error) => {
                                this.exibirErro(error)
                            });
                        }
                    }

                    this.requisicao.valorJuros = null;
                    if(this.valoresJuros.length > 0) {
                        let valorHonorariosCorrigido = parseFloat(valorHonorarios) +
                            (this.requisicao.valorCorrecao != null ? this.requisicao.valorCorrecao : 0) -
                            (this.requisicao.valoresAnteriores != null ? this.requisicao.valoresAnteriores : 0);
                        this.requisicao.valorJuros = 0;
                        if(valorHonorariosCorrigido > 0) {
                            for(var i = 0; i < this.valoresJuros.length; i++) {
                                this.requisicao.valorJuros += parseFloat(valorHonorariosCorrigido) * (this.valoresJuros[i].variacao / 100);
                            }
                        }
                    }
                }
            },
            executarCalculos() {
                this.$store.commit("setMessages", {});
                if(!this.validarDatas() || (this.requisicao.tipoPagamento != null && !this.validarValoresAnteriores())) {
                    return false;
                } else {
                    this.aplicarCorrecaoJuros();
                    return true;
                }
            },
            validacaoTipoPagamento() {
                if(this.executarCalculos()) {
                    if(this.requisicao.indiceCorrecao != null && !this.requisicao.modalDatas &&
                        (this.requisicao.inicioCorrecao == null || this.requisicao.inicioCorrecao == "") &&
                        (this.requisicao.fimCorrecao == null || this.requisicao.fimCorrecao == "") &&
                        this.requisicao.deduzirPagamentos == true) {
                        this.$refs['modal-datas'].show();
                        this.requisicao.modalDatas = true;
                    }
                } else {
                    setTimeout(()=>{
                        if(this.requisicao.titularReceita != 1) {
                            this.requisicao.tipoPagamento = null;
                        }
                        this.requisicao.regraParcelamento = null;
                    }, 500);
                }
            },
            openModalDatas() {
                this.$refs['modal-datas'].show();
            },
            preencherDataCorrecao() {
                if(this.requisicao.titularReceita != 1) {
                    this.requisicao.tipoPagamento = null;
                }
                this.requisicao.regraParcelamento = null;
                this.$refs['modal-datas'].hide();
            },
            validarDatas() {
                this.validations.fimCorrecao.valid = true;
                this.validations.inicioCorrecao.valid = true;
                this.validations.fimJuros.valid = true;
                this.validations.inicioJuros.valid = true;
                
                if(((this.requisicao.inicioCorrecao != null && this.requisicao.inicioCorrecao._i != null) && this.requisicao.inicioCorrecao != "") &&
                        (this.requisicao.fimCorrecao == null || this.requisicao.fimCorrecao == "")) {
                    this.validations.fimCorrecao.valid = false;
                    this.validations.fimCorrecao.message = 'A data Fim da Correção é obrigatória.';
                    return false;
                } else if((this.requisicao.inicioCorrecao == null || this.requisicao.inicioCorrecao == "") &&
                        ((this.requisicao.fimCorrecao != null && this.requisicao.fimCorrecao._i != null) && this.requisicao.fimCorrecao != "")) {
                    this.validations.inicioCorrecao.valid = false;
                    this.validations.inicioCorrecao.message = 'A data Início da Correção é obrigatória.';
                    return false;
                } else if(((this.requisicao.inicioCorrecao != null && this.requisicao.inicioCorrecao._i != null) && this.requisicao.inicioCorrecao != "") &&
                        ((this.requisicao.fimCorrecao != null && this.requisicao.fimCorrecao._i != null) && this.requisicao.fimCorrecao != "")) {
                    let anoInicial = parseInt(this.requisicao.inicioCorrecao._i.split("/")[0]);
                    let mesInicial = parseInt(this.requisicao.inicioCorrecao._i.split("/")[1]);
                    let anoFinal = parseInt(this.requisicao.fimCorrecao._i.split("/")[0]);
                    let mesFinal = parseInt(this.requisicao.fimCorrecao._i.split("/")[1]);

                    var dataAtual = new Date();
                    let ano = dataAtual.getFullYear();
                    let mes = dataAtual.getMonth() + 1;

                    if(anoInicial > ano || (anoInicial == ano && mesInicial >= mes)) {
                        this.validations.inicioCorrecao.valid = false;
                        this.validations.inicioCorrecao.message = 'A data Início da Correção deve ser menor que a data atual.';
                        return false;
                    } else if(anoFinal > ano || (anoFinal == ano && mesFinal > mes)) {
                        this.validations.fimCorrecao.valid = false;
                        this.validations.fimCorrecao.message = 'A data Final da Correção deve ser menor ou igual a data atual.';
                        return false;
                    } else if(anoInicial > anoFinal || (anoInicial == anoFinal && mesInicial > mesFinal)) {
                        this.validations.fimCorrecao.valid = false;
                        this.validations.fimCorrecao.message = 'A data Fim da Correção deve ser maior ou igual que a data Início da Correção.';
                        return false;
                    }
                }

                if(((this.requisicao.inicioJuros != null && this.requisicao.inicioJuros._i != null) && this.requisicao.inicioJuros != "") &&
                    (this.requisicao.fimJuros == null || this.requisicao.fimJuros == "")) {
                    this.validations.fimJuros.valid = false;
                    this.validations.fimJuros.message = 'A data Fim dos Juros deve ser informada junto a data Início dos Juros.';
                    return false;
                } else if((this.requisicao.inicioJuros == null || this.requisicao.inicioJuros == "") &&
                    ((this.requisicao.fimJuros != null && this.requisicao.fimJuros._i != null) && this.requisicao.fimJuros != "")) {
                    this.validations.inicioJuros.valid = false;
                    this.validations.inicioJuros.message = 'A data Início dos Juros deve ser informada junto a data Fim dos Juros.';
                    return false;
                } else if(((this.requisicao.inicioJuros != null && this.requisicao.inicioJuros._i != null) && this.requisicao.inicioJuros != "") &&
                    ((this.requisicao.fimJuros != null && this.requisicao.fimJuros._i != null) && this.requisicao.fimJuros != "")) {
                    let anoInicial = parseInt(this.requisicao.inicioJuros._i.split("/")[0]);
                    let mesInicial = parseInt(this.requisicao.inicioJuros._i.split("/")[1]);
                    let anoFinal = parseInt(this.requisicao.fimJuros._i.split("/")[0]);
                    let mesFinal = parseInt(this.requisicao.fimJuros._i.split("/")[1]);

                    var dataAtual = new Date();
                    let ano = dataAtual.getFullYear();
                    let mes = dataAtual.getMonth() + 1;

                    if(anoInicial > ano || (anoInicial == ano && mesInicial >= mes)) {
                        this.validations.inicioJuros.valid = false;
                        this.validations.inicioJuros.message = 'A data Início dos Juros deve ser menor que a data Atual.';
                        return false;
                    } else if(anoFinal > ano || (anoFinal == ano && mesFinal > mes)) {
                        this.validations.fimJuros.valid = false;
                        this.validations.fimJuros.message = 'A data Fim dos Juros deve ser menor ou igual a data Atual.';
                        return false;
                    } else if(anoInicial > anoFinal || (anoInicial == anoFinal && mesInicial > mesFinal)) {
                        this.validations.fimJuros.valid = false;
                        this.validations.fimJuros.message = 'A data Fim dos Juros deve ser maior ou igual que a data Início dos Juros.';
                        return false;
                    }
                }

                if(this.requisicao.indiceJuros != null && this.requisicao.indiceCorrecao != null
                        && ((this.requisicao.inicioJuros != null && this.requisicao.inicioJuros._i != null) && this.requisicao.inicioJuros != "")
                        && ((this.requisicao.inicioCorrecao != null && this.requisicao.inicioCorrecao._i != null) && this.requisicao.inicioCorrecao != "")) {
                    for(let i = 0; i < this.dados.indiceJuros.length; i++) {
                        if(this.dados.indiceJuros[i].codIndice == this.requisicao.indiceJuros
                                && this.dados.indiceJuros[i].descricao.toUpperCase().trim() == "SELIC") {

                            let anoInicialJuros = parseInt(this.requisicao.inicioJuros._i.split("/")[0]);
                            let mesInicialJuros = parseInt(this.requisicao.inicioJuros._i.split("/")[1]);
                            let anoFinalJuros = parseInt(this.requisicao.fimJuros._i.split("/")[0]);
                            let mesFinalJuros = parseInt(this.requisicao.fimJuros._i.split("/")[1]);

                            let anoInicialCorrecao = parseInt(this.requisicao.inicioCorrecao._i.split("/")[0]);
                            let mesInicialCorrecao = parseInt(this.requisicao.inicioCorrecao._i.split("/")[1]);
                            let anoFinalCorrecao = parseInt(this.requisicao.fimCorrecao._i.split("/")[0]);
                            let mesFinalCorrecao = parseInt(this.requisicao.fimCorrecao._i.split("/")[1]);

                            if((anoInicialCorrecao >= anoInicialJuros && mesInicialCorrecao >= mesInicialJuros
                                    && anoInicialCorrecao <= anoFinalJuros && mesInicialCorrecao <= mesFinalJuros) ||
                                (anoFinalCorrecao >= anoInicialJuros && mesFinalCorrecao >= mesInicialJuros
                                    && anoFinalCorrecao <= anoFinalJuros && mesFinalCorrecao <= mesFinalJuros)) {
                                this.exibirMensagem("Os intervalos entre Início da Correção e Fim da Correção, e Início dos Juros e Fim dos Juros não poderão coincidir parcial ou totalmente. Tente novamente");
                                return false;
                            }
                        }
                    }
                }

                return true;
            },
            validarDataCorrecao() {
                if(((this.requisicao.inicioCorrecao != null && this.requisicao.inicioCorrecao._i != null) && this.requisicao.inicioCorrecao != "") &&
                        ((this.requisicao.fimCorrecao != null && this.requisicao.fimCorrecao._i != null) && this.requisicao.fimCorrecao != "")) {
                    let anoInicial = parseInt(this.requisicao.inicioCorrecao._i.split("/")[0]);
                    let mesInicial = parseInt(this.requisicao.inicioCorrecao._i.split("/")[1]);
                    let anoFinal = parseInt(this.requisicao.fimCorrecao._i.split("/")[0]);
                    let mesFinal = parseInt(this.requisicao.fimCorrecao._i.split("/")[1]);

                    var dataAtual = new Date();
                    let ano = dataAtual.getFullYear();
                    let mes = dataAtual.getMonth() + 1;

                    if(anoInicial > anoFinal || (anoInicial == anoFinal && mesInicial > mesFinal)) {
                        this.validations.fimCorrecao.valid = false;
                        this.validations.fimCorrecao.message = 'A data de fim deve ser maior que a data de início!';
                        return;
                    }
                }
                this.validations.fimCorrecao.valid = true;
            },
            validarDataJuros() {
                if(((this.requisicao.inicioJuros != null && this.requisicao.inicioJuros._i != null) && this.requisicao.inicioJuros != "") &&
                        ((this.requisicao.fimJuros != null && this.requisicao.fimJuros._i != null) && this.requisicao.fimJuros != "")) {
                    let anoInicial = parseInt(this.requisicao.inicioJuros._i.split("/")[0]);
                    let mesInicial = parseInt(this.requisicao.inicioJuros._i.split("/")[1]);
                    let anoFinal = parseInt(this.requisicao.fimJuros._i.split("/")[0]);
                    let mesFinal = parseInt(this.requisicao.fimJuros._i.split("/")[1]);

                    var dataAtual = new Date();
                    let ano = dataAtual.getFullYear();
                    let mes = dataAtual.getMonth() + 1;

                    if(anoInicial > anoFinal || (anoInicial == anoFinal && mesInicial > mesFinal)) {
                        this.validations.fimJuros.valid = false;
                        this.validations.fimJuros.message = 'A data de fim deve ser maior que a data de início!';
                        return;
                    }
                }
                this.validations.fimJuros.valid = true;
            },
            validarValoresAnteriores() {
                if(this.requisicao.deduzirPagamentos == true && this.requisicao.indiceCorrecao == null) {
                    this.exibirMensagem("Para deduzir pagamento(s) anterior(es), é necessária a indicação de um índice de correção monetária no campo \"Índice de Correção\", a ser utilizado pelo sistema na atualização dos pagamento(s) anterior(es)");
                    return false;
                }

                return true;
            },
            possuiQuitadasRescindidas() {
                for(var i = 0; i < this.items.length; i++) {
                    if(this.items[i].situacao == 'Quitada' || this.items[i].situacao == 'Rescindido') {
                        return true;
                    }
                }

                return false;
            },
            somarQuitadasRescindidas() {
                let valor = 0;
                for(var i = 0; i < this.items.length; i++) {
                    if(this.items[i].situacao == 'Quitada' || this.items[i].situacao == 'Rescindido') {
                        valor += this.items[i].valor;
                    }
                }

                return valor;
            },
            listarFormaPagamentoPorTipo() {
                let formaPagamento = [];

                if (this.dados.formasPagamento.length > 0) {
                    if (this.requisicao.tipoPagamento == 1) {
                        formaPagamento.push({
                            value: this.dados.formasPagamento[0].id, 
                            text: this.dados.formasPagamento[0].nome ? this.dados.formasPagamento[0].nome : 'NENHUM'
                        });

                        this.requisicao.formaPagamento = this.dados.formasPagamento[0].id;
                    } else {
                        formaPagamento.push({
                            value: this.dados.formasPagamento[0].id, 
                            text: this.dados.formasPagamento[0].nome ? this.dados.formasPagamento[0].nome : 'NENHUM'
                        });

                        if (this.requisicao != null && this.requisicao.titularReceita == 0) {
                            formaPagamento.push({
                                value: this.dados.formasPagamento[1].id, 
                                text: this.dados.formasPagamento[1].nome ? this.dados.formasPagamento[1].nome : 'NENHUM'
                            });
                        } else {
                            formaPagamento.push({
                                value: this.dados.formasPagamento[2].id, 
                                text: this.dados.formasPagamento[2].nome ? this.dados.formasPagamento[2].nome : 'NENHUM'
                            });

                            this.requisicao.formaPagamento = this.dados.formasPagamento[0].id;
                        }
                    }
                }


                this.formaPagamentoLista = formaPagamento;
            },
            abrirModalArtigo85() {
                this.messageModal.message = null;
                if(this.requisicao.valorBaseCalculo != null && this.requisicao.valorBaseCalculo.length > 0) {
                    this.dataSentencaTemp = this.requisicao.dataSentenca;
                    this.salarioMinimoTemp = this.requisicao.salarioMinimo;
                    this.quantidadeSalariosTemp = this.requisicao.quantidadeSalarios;
                    this.faixasTemp = [];
                    for(var i = 0; i < this.faixas.length; i++) {
                        this.faixasTemp.push({
                           ... this.faixas[i]
                        });
                    }

                    this.quantidadeSalarios();
                    this.$refs['modal-regras'].show();
                }
            },
            cancelarRegras() {
                this.requisicao.dataSentenca = this.dataSentencaTemp;
                this.requisicao.salarioMinimo = this.salarioMinimoTemp;
                this.requisicao.quantidadeSalarios = this.quantidadeSalariosTemp;
                this.$emit('voltarFaixas', this.faixasTemp);
                this.$refs['modal-regras'].hide();
            },
            salvarRegras() {
                let valido = true;
                for(var i = 0; i < this.faixas.length; i++) {
                    if(this.faixas[i].informar && (this.faixas[i].percentual == null
                        || this.faixas[i].percentual === ""
                        || parseFloat(this.tratarCamposNumericos(this.faixas[i].percentual)) > parseFloat(this.faixas[i].percentualMaximo)
                        || parseFloat(this.tratarCamposNumericos(this.faixas[i].percentual)) < parseFloat(this.faixas[i].percentualMinimo))) {
                        valido = false;
                        this.$refs['faixa' + this.faixas[i].percentualMinimo].$el.focus();
                    }
                }

                if(valido) {
                    this.$refs['modal-regras'].hide();
                    this.executarCalculos();
                }
            },
            regrasValidas() {
                if(this.faixas == null || this.faixas.length <= 0) {
                    return false;
                }

                let possuiFaixa = false;
                for(var i = 0; i < this.faixas.length; i++) {
                    if(this.faixas[i].informar) {
                        possuiFaixa = true;
                        if (this.faixas[i].percentual == null
                            || this.faixas[i].percentual === ""
                            || parseFloat(this.tratarCamposNumericos(this.faixas[i].percentual)) > parseFloat(this.faixas[i].percentualMaximo)
                            || parseFloat(this.tratarCamposNumericos(this.faixas[i].percentual)) < parseFloat(this.faixas[i].percentualMinimo)) {
                            return false;
                        }
                    }
                }

                return possuiFaixa;
            },
            verificarFaixasInformadas() {
                for(var i = 0; i < this.faixas.length; i++) {
                    if(this.faixas[i].informar && (this.faixas[i].percentual == null
                            || this.faixas[i].percentual === ""
                            || parseFloat(this.tratarCamposNumericos(this.faixas[i].percentual)) > parseFloat(this.faixas[i].percentualMaximo)
                            || parseFloat(this.tratarCamposNumericos(this.faixas[i].percentual)) < parseFloat(this.faixas[i].percentualMinimo))) {
                        return false;
                    }
                }

                return true;
            },
            obterValorItem(item) {
                if(item.percentual == "" || item.percentual == null) {
                    return null;
                }
                return ((item.baseIncidencia * parseFloat(this.tratarCamposNumericos(item.percentual))) / 100);
            },
            alterarTipoPercentual() {
                if(this.requisicao.percentual) {
                    this.abrirModalArtigo85();
                }
                this.reiniciarValores();
            },
            limparCamposPagamento() {
                this.validations.tipoPagamentoParcela.valid = true;
                this.validations.tipoPagamento.valid = true;
                if(this.requisicao.titularReceita != 1) {
                    this.requisicao.pagamento = null;
                    this.requisicao.tipoPagamento = null;
                    this.requisicao.formaPagamento = null;
                }
                this.requisicao.regraParcelamento = null;
                this.requisicao.numeroParcelas = null;
                this.requisicao.numeroParcelasFixo = null;
                this.requisicao.indiceReajuste = null;
                this.requisicao.deliberacao = null;
                this.requisicao.sid = null;
            },
            validarFaixa(item) {
                let ref = "";
                for(var i = 0; i < this.faixas.length; i++) {
                    if(this.faixas[i].percentual == null
                        || this.faixas[i].percentual === ""
                        || parseFloat(this.tratarCamposNumericos(this.faixas[i].percentual)) > parseFloat(this.faixas[i].percentualMaximo)
                        || parseFloat(this.tratarCamposNumericos(this.faixas[i].percentual)) < parseFloat(this.faixas[i].percentualMinimo)) {
                        ref = 'faixa' + this.faixas[i].percentualMinimo;
                        this.$refs[ref].$el.classList.value = 'form-control is-invalid';
                        setTimeout(()=>{
                            this.$refs[ref].$el.focus();
                        }, 0);
                        break;
                    } else {
                        this.$refs['faixa' + this.faixas[i].percentualMinimo].$el.classList.value = 'form-control';
                        this.faixas[i].invalid = false;
                    }
                }
            },
            alterarMinDataCorrecao() {
                this.minDataCorrecao = null;
                for(var i = 0; i < this.dados.indiceCorrecao.length; i++) {
                    if(this.dados.indiceCorrecao[i].codIndice == this.requisicao.indiceCorrecao
                        && this.dados.indiceCorrecao[i].dataInicio != null
                        && this.dados.indiceCorrecao[i].dataInicio != ''
                        && this.dados.indiceCorrecao[i].dataInicio.length == 6) {
                        this.minDataCorrecao = moment(this.dados.indiceCorrecao[i].dataInicio, "YYYYMM");
                        this.maxDataCorrecao = moment(this.dados.indiceCorrecao[i].dataFim, "YYYYMM");
                        
                        this.minDataFimCorrecao = moment(this.dados.indiceCorrecao[i].dataInicio, "YYYYMM").add(1, 'M');
                        this.maxDataFimCorrecao = moment(this.dados.indiceCorrecao[i].dataFim, "YYYYMM").add(1, 'M');
                    }
                }
            },
            alterarMinDataJuros() {
                this.minDataJuros = null;
                for(var i = 0; i < this.dados.indiceJuros.length; i++) {
                    if(this.dados.indiceJuros[i].codIndice == this.requisicao.indiceJuros
                        && this.dados.indiceJuros[i].dataInicio != null
                        && this.dados.indiceJuros[i].dataInicio != ''
                        && this.dados.indiceJuros[i].dataInicio.length == 6) {
                        this.minDataJuros = moment(this.dados.indiceJuros[i].dataInicio, "YYYYMM");
                        this.maxDataJuros = moment(this.dados.indiceJuros[i].dataFim, "YYYYMM");

                        this.minDataFimJuros = moment(this.dados.indiceJuros[i].dataInicio, "YYYYMM").add(1, 'M');
                        this.maxDataFimJuros = moment(this.dados.indiceJuros[i].dataFim, "YYYYMM").add(1, 'M');
                    }
                }
            },
            mudarPagamento(force) {
                this.requisicao.indiceReajuste = null;
                this.requisicao.numeroParcelasFixo = null;
                this.requisicao.numeroParcelas = null;

                this.validations.indiceReajuste.valid = true;
                this.validations.numeroParcelas.valid = true;
                this.validations.numeroParcelasFixo.valid = true;
                this.validations.deliberacao.valid = true;
                this.validations.sid.valid = true;

                if(this.requisicao.pagamento != null) {
                    if (this.requisicao.pagamento.aVista) {
                        this.requisicao.formaPagamento = 1;
                    } else if(!force) {
                        this.requisicao.indiceReajuste = null;
                        for (var i = 0; i < this.dados.indiceReajuste.length; i++) {
                            if (this.dados.indiceReajuste[i].codIndice == this.requisicao.pagamento.codIndiceSugerir) {
                                this.requisicao.indiceReajuste = this.requisicao.pagamento.codIndiceSugerir;
                            }
                        }
                    }
                    this.requisicao.tipoPagamento = this.requisicao.pagamento.aVista ? 0 : 1;
                    this.requisicao.regraParcelamento = this.requisicao.pagamento.parcelas ? 0 : 1;
                } else {
                    this.requisicao.formaPagamento = null;
                    this.requisicao.tipoPagamento = null;
                    this.requisicao.regraParcelamento = null;
                }

            },
            invalidateCotas(valid) {
                this.validations.cota.valid = valid;
            },
            invalidateDataTransferencia(valid) {
                this.validations.dataTransferencia.valid = valid;
            },
            isValid() {
                return this.validations.tipoPagamentoParcela.valid
                    && this.validations.tipoPagamento.valid
                    && this.validations.cota.valid
                    && this.validations.cpf.valid
                    && this.validations.dataTransferencia.valid
                    && this.validations.indice.valid
                    && this.validations.fimCorrecao.valid
                    && this.validations.fimJuros.valid;
            },
            validarIndice() {
                let valor = this.tratarCamposNumericos(this.requisicao.valorIndice);

                if(valor <= 0) {
                    this.validations.indice.valid = false;
                    this.validations.indice.message = 'O Índice deve ser maior que 0!';
                } else {
                    this.validations.indice.valid = true;
                }
            },
            validarValor() {
                let valor;
                if(this.requisicao.honorarioFixo == true) {
                    valor = this.tratarCamposNumericos(this.requisicao.valorFixo);
                } else {
                    valor = this.tratarCamposNumericos(this.requisicao.valorBaseCalculo);
                }

                if(valor <= 0) {
                    this.$emit('alterarValidadeValor', false);
                } else {
                    this.$emit('alterarValidadeValor', true);
                }
            },
            reiniciarValidacaoValor() {
                this.$emit('alterarValidadeValor', true);
            },
            datasJurosObrigatorias(valid) {
                this.validations.inicioJuros.valid = valid;
                if(!valid) {
                    this.validations.inicioJuros.message = 'O campo Início dos Juros é obrigatório.';
                }
                this.validations.fimJuros.valid = valid;
                if(!valid) {
                    this.validations.fimJuros.message = 'O campo Fim dos Juros é obrigatório.';
                }
            },
            datasCorrecaoObrigatorias(valid) {
                this.validations.inicioCorrecao.valid = valid;
                if(!valid) {
                    this.validations.inicioCorrecao.message = 'O campo Início da Correção é obrigatório.';
                }
                this.validations.fimCorrecao.valid = valid;
                if(!valid) {
                    this.validations.fimCorrecao.message = 'O campo Fim da Correção é obrigatório.';
                }
            },
            verificarObrigatoriedade() {
                let valid = true;
                this.validations.cpf.valid = true;
                this.validations.honorarioFixo.valid = true;
                this.validations.valorFixo.valid = true;
                this.validations.valorBaseCalculo.valid = true;
                this.validations.indice.valid = true;
                this.validations.pagamento.valid = true;
                this.validations.formaPagamento.valid = true;
                this.validations.indiceReajuste.valid = true;
                this.validations.numeroParcelas.valid = true;
                this.validations.numeroParcelasFixo.valid = true;
                this.validations.deliberacao.valid = true;
                this.validations.sid.valid = true;
                this.validations.percentual.valid = true;


                if(this.devedor.codDevedor == null) {
                    this.validations.cpf.valid = false;
                    this.validations.cpf.message = 'Informe um devedor existente ou inclua um novo';
                    valid = false;
                }
                if(this.verificarValorVazio(this.requisicao.honorarioFixo)) {
                    this.validations.honorarioFixo.valid = false;
                    this.validations.honorarioFixo.message = 'O campo Escolha uma das Regras de Cálculo é obrigatório.';
                    valid = false;
                }
                if(this.requisicao.honorarioFixo && this.verificarValorVazio(this.requisicao.valorFixo)) {
                    this.validations.valorFixo.valid = false;
                    this.validations.valorFixo.message = 'O campo Valor Fixo é obrigatório.';
                    valid = false;
                }
                if(!this.requisicao.honorarioFixo && this.verificarValorVazio(this.requisicao.percentual)) {
                    this.validations.percentual.valid = false;
                    this.validations.percentual.message = 'O campo Percentual é obrigatório.';
                    valid = false;
                }
                if(!this.requisicao.honorarioFixo && this.verificarValorVazio(this.requisicao.valorBaseCalculo)) {
                    this.validations.valorBaseCalculo.valid = false;
                    this.validations.valorBaseCalculo.message = 'O campo Valor da Base de Cálculo é obrigatório.';
                    valid = false;
                }
                if(!this.requisicao.honorarioFixo && !this.requisicao.percentual && this.verificarValorVazio(this.requisicao.valorIndice)) {
                    this.validations.indice.valid = false;
                    this.validations.indice.message = 'O campo Índice é obrigatório.';
                    valid = false;
                }
                if(this.verificarValorVazio(this.requisicao.pagamento)) {
                    this.validations.pagamento.valid = false;
                    this.validations.pagamento.message = 'O campo Tipo de Pagamento é obrigatório.';
                    valid = false;
                }

                if(this.verificarValorVazio(this.requisicao.formaPagamento)) {
                    this.validations.formaPagamento.valid = false;
                    this.validations.formaPagamento.message = 'O campo Forma de Pagamento é obrigatório.';
                    valid = false;
                }

                if(this.requisicao.tipoPagamento == 1) {
                    if(this.verificarValorVazio(this.requisicao.indiceReajuste)) {
                        this.validations.indiceReajuste.valid = false;
                        this.validations.indiceReajuste.message = 'O campo Escolha o Índice de Reajuste das Parcela é obrigatório.';
                        valid = false;
                    }
                    if(this.requisicao.pagamento && this.requisicao.pagamento.parcelas && this.verificarValorVazio(this.requisicao.numeroParcelas)) {
                        this.validations.numeroParcelas.valid = false;
                        this.validations.numeroParcelas.message = 'O campo Escolha o número de Parcelas é obrigatório.';
                        valid = false;
                    }

                    if(this.requisicao.pagamento && !this.requisicao.pagamento.parcelas && this.verificarValorVazio(this.requisicao.numeroParcelasFixo)) {
                        this.validations.numeroParcelasFixo.valid = false;
                        this.validations.numeroParcelasFixo.message = 'O campo Informe o Número de Parcelas é obrigatório.';
                        valid = false;
                    }

                    if(this.requisicao.pagamento && this.requisicao.pagamento.delibSid && this.verificarValorVazio(this.requisicao.deliberacao)) {
                        this.validations.deliberacao.valid = false;
                        this.validations.deliberacao.message = 'O campo Nº Deliberação Conselho é obrigatório.';
                        valid = false;
                    }

                    if(this.requisicao.pagamento && this.requisicao.pagamento.delibSid && this.verificarValorVazio(this.requisicao.sid)) {
                        this.validations.sid.valid = false;
                        this.validations.sid.message = 'O campo SID é obrigatório.';
                        valid = false;
                    }
                }

                return valid;
            },
		    iniciarDeducoes() {
			    if (this.requisicao.deduzirPagamentos) {
				    this.showModal('modal-deduzir');
			    } else {
				    this.executarCalculos();
				    this.limparCamposPagamento();
			    }
		    },
		    fecharModalAvisoDeducoes() {
			    this.executarCalculos();
			    this.limparCamposPagamento();
		    },
            validarEmails(listaDevedores) {

                if(listaDevedores.length > 0) {
                    for(var i = 0; i < listaDevedores.length; i++) {
                        if(listaDevedores[i].email ||
                            listaDevedores[i].emailAlternativo1 ||
                            listaDevedores[i].emailAlternativo2) {
                            return true;
                        }
                    }
                }
                return false; // Nenhum email encontrado
            }
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.listarIndiceCorrecao();
            this.listarIndiceJuros();
            this.listarIndiceReajuste();
            this.listarFormaPagamento();
        }
    }
</script>
<style scoped>
    .icon-button {
        font-size: 1.5rem;
        margin-left: 1rem;
        padding: 0 0.5rem;
    }

    .vertical-middle {
        vertical-align: middle;
    }
</style>
